import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-8">
          用户口碑
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {commentItems.slice(0, 4).map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 max-w-2xl mx-auto">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-background-200 overflow-hidden flex-shrink-0">
                <img
                  src={commentItems[4].avatar}
                  alt={commentItems[4].name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div>
                <div className="text-sm font-medium text-foreground-800">{commentItems[4].name}</div>
                <div className="text-xs text-foreground-400">{commentItems[4].time}</div>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{commentItems[4].text}</p>
          </div>
        </div>
      </div>
    </section>
  );
}